<template>
  <div>
    <div class="flex-center py-4" v-if="loadingState === LoadingState.LOADING">
      <spinner />
    </div>
    <div
      class="message-section text-secondary d-flex align-items-center"
      v-else-if="loadingState === LoadingState.ERRORED"
    >
      Unable to fetch initiatives.
      <b-button variant="link" class="text-secondary py-0" pill size="sm" @click="$emit('fetch')"
        >Try again
      </b-button>
    </div>
    <template v-else-if="initiatives && initiatives.length > 0">
      <div
        class="d-flex initiative position-relative"
        v-for="initiative in initiatives"
        :key="initiative.id"
      >
        <initiative-icon
          class="initiative-icon-container"
          :is-done-and-closed="initiative.isDoneAndClosed"
        />
        <span class="pl-1 initiative-title" v-no-capture>{{ initiative.title }}</span>
        <div class="move-btn-wrapper position-absolute flex-center">
          <b-button
            class="text-nowrap"
            @click="$emit('move', { parentId: initiative.id })"
            pill
            variant="primary"
            size="sm"
            >Move to this Initiative
          </b-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import InitiativeIcon from '@/components/initiative/InitiativeIcon.vue'
import Spinner from '@/components/Spinner.vue'
import { LoadingState } from '@/constants/common'
import { BButton } from 'bootstrap-vue'

/**
 * This shows a blocks with list of initiatives. This is used for moving initiatives to another initiative. This action
 * would make source initiatives as tasks.
 */
export default {
  name: 'MoveToInitiativesSection',
  components: { BButton, InitiativeIcon, Spinner },
  props: ['initiatives', 'loadingState'],
  data() {
    return {
      LoadingState
    }
  },
  computed: {}
}
</script>

<style scoped lang="scss">
@import '~@/styles/_styleConfigurations.scss';

.initiative-icon-container {
  margin-top: 6px;
}

.initiative {
  padding: 0 16px;
  border-radius: 16px;
}

.initiative-title {
  padding: 4px 0;
}

.move-btn-wrapper {
  right: 0;
  top: 0;
  bottom: 0;
  background-color: $documentColor;
  font-weight: 600;
  display: none;
  padding: 0 5px 0 4px;

  /deep/ button {
    padding: 1px 12px;
  }
}

.initiative {
  &:hover {
    background-color: $selectionColor;
    .move-btn-wrapper {
      background-color: $selectionColor;
      display: flex;
      transform: translateX(0);
    }
  }
}
</style>
